import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  useTheme,
} from "@mui/material";
import { AdminPanelSettings } from "@mui/icons-material";

const NAV_ICONS = {
  admin: AdminPanelSettings,
};

const getItemSx = (theme, { isLogout = false } = {}) => ({
  mx: 0.5,
  my: 0.25,
  px: 1.5,
  py: 1.25,
  borderRadius: 1.5,
  color: theme.palette.text.primary,
  ...(isLogout && { minHeight: 48 }),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

const MoreMenu = ({
  anchorEl,
  open,
  onClose,
  navItems = [],
  onNavigate,
  onLogout,
}) => {
  const theme = useTheme();

  return (
    <Menu
      id="sidebar-more-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      disableScrollLock
      MenuListProps={{
        "aria-labelledby": "sidebar-more-button",
        sx: { py: 0.75 },
      }}
      PaperProps={{
        elevation: 8,
        sx: {
          minWidth: 270,
          borderRadius: 2,
          bgcolor: "background.paper",
          color: "text.primary",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[8],
          mb: 1.5,
          overflow: "hidden",
        },
      }}
    >
      {navItems.map((item) => {
        const Icon = NAV_ICONS[item.id];
        return (
          <MenuItem
            key={item.id}
            component={RouterLink}
            to={item.path}
            onClick={onNavigate}
            sx={getItemSx(theme)}
          >
            {Icon && (
              <ListItemIcon sx={{ color: "text.secondary", minWidth: 40 }}>
                <Icon fontSize="small" />
              </ListItemIcon>
            )}
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{ fontSize: "0.95rem" }}
            />
          </MenuItem>
        );
      })}
      {navItems.length > 0 && <Divider sx={{ my: 0.75 }} />}
      <MenuItem onClick={onLogout} sx={getItemSx(theme, { isLogout: true })}>
        <ListItemText
          primary="Logout"
          primaryTypographyProps={{ fontSize: "0.95rem" }}
        />
      </MenuItem>
    </Menu>
  );
};

export default MoreMenu;
